import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthInterceptor } from "./interceptors/auth-interceptor";
import { ApiInterceptor } from "./interceptors/api-interceptor";
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import { FormsModule }   from '@angular/forms';
import { LOCALE_ID } from "@angular/core";
import { FullCalendarModule } from '@fullcalendar/angular';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionlugin from '@fullcalendar/interaction';
import timeGridlugin from '@fullcalendar/timegrid';
import listPlugin from '@fullcalendar/list';
import {NgxPaginationModule} from 'ngx-pagination';

import localeEs from '@angular/common/locales/es';
import { registerLocaleData } from '@angular/common';
registerLocaleData(localeEs);

import { AgmCoreModule } from '@agm/core'; 
import { AgmDirectionModule } from 'agm-direction';

//Rutas
import { APP_ROUTING } from "./app.routes";

//Servicios
import { AuthService } from "./services/auth.service";

//Componentes
import { AppComponent } from './app.component';
import { NavbarComponent } from './components/shared/navbar/navbar.component';
import { LoginComponent } from './components/home/login/login.component';
import { PrincipalComponent } from './components/home/principal/principal.component';
import { PathComponent } from './components/error/path/path.component';
import { UsersComponent } from './components/home/users/users.component';
import { AuthComponent } from './components/home/auth/auth.component';
import { CustomersComponent } from './components/home/customers/customers.component';
import { ConfComponent } from './components/home/conf/conf.component';
import { SupplierComponent } from './components/home/supplier/supplier.component';
import { UnityComponent } from './components/home/unity/unity.component';
import { UnityCardComponent } from './components/home/unity/unity-card/unity-card.component';
import { UnitySingleComponent } from './components/home/unity/unity-single/unity-single.component';
import { ProductComponent } from './components/home/product/product.component';
import { OrderComponent } from './components/home/order/order.component';
import { OrderCreateComponent } from './components/home/order/order-create/order-create.component';
import { DriverComponent } from './components/home/driver/driver.component';
import { ExpenseComponent } from './components/home/expense/expense.component';
import { RouteComponent } from './components/home/route/route.component';
import { RouteNewComponent } from './components/home/route-new/route-new.component';
import { AddressPipe } from './pipes/address.pipe';
import { PostalCodeComponent } from './components/shared/postal-code/postal-code.component';
import { RouteCreateComponent } from './components/home/route/route-create/route-create.component';
import { RouteCardComponent } from './components/home/route/route-card/route-card.component';
import { SetComponent } from './components/home/unity/set/set.component';
import { SetCardComponent } from './components/home/unity/set-card/set-card.component';
import { RouteTestComponent } from './components/home/route/route-test/route-test.component';
import { ArticleComponent } from './components/home/article/article.component';
import { TravelListComponent } from './components/home/travel/travel-list/travel-list.component';
import { TravelCreateComponent } from './components/home/travel/travel-create/travel-create.component';
import { TravelSingleComponent } from './components/home/travel/travel-single/travel-single.component';
import { MaintenanceOrderCreateComponent } from './components/home/maintenance/maintenance-order-create/maintenance-order-create.component';
import { MaintenanceOrderListComponent } from './components/home/maintenance/maintenance-order-list/maintenance-order-list.component';
import { MaintenanceOrderCardComponent } from './components/home/maintenance/maintenance-order-card/maintenance-order-card.component';
import { UnityPipe } from './pipes/unity.pipe';
import { CalendarComponent } from './components/home/travel/calendar/calendar.component';
import { CalendarCardComponent } from './components/home/travel/calendar-card/calendar-card.component';
import { PaysheetExpensesComponent } from './components/home/travel/paysheet-expenses/paysheet-expenses.component';
import { GasTicketComponent } from './components/home/travel/gas-ticket/gas-ticket.component';
import { MaintenanceCreateComponent } from './components/home/maintenance/maintenance-create/maintenance-create.component';
import { MaintenanceListComponent } from './components/home/maintenance/maintenance-list/maintenance-list.component';
import { ExtraExpenseComponent } from './components/home/extra-expense/extra-expense.component';
import { PaysheetComponent } from './components/home/paysheet/paysheet.component';
import { MarketPriceComponent } from './components/home/market-price/market-price.component';
import { PaysheetBaseComponent } from './components/home/paysheet/paysheet-base/paysheet-base.component';
import { GasReportComponent } from './components/home/reports/gas-report/gas-report.component';
import { MaintenanceReportComponent } from './components/home/reports/maintenance-report/maintenance-report.component';
import { ExtraExpenseReportComponent } from './components/home/reports/extra-expense-report/extra-expense-report.component';
import { PaysheetReportComponent } from './components/home/reports/paysheet-report/paysheet-report.component';
import { OrderEditComponent } from './components/home/order/order-edit/order-edit.component';
import { RoleAbilityComponent } from './components/home/auth/role-ability/role-ability.component';
import { AbilityToRoleComponent } from './components/home/auth/ability-to-role/ability-to-role.component';
import { TravelCardComponent } from './components/home/travel/travel-card/travel-card.component';
import { RouteEditComponent } from './components/home/route/route-edit/route-edit.component';
import { OrderSingleComponent } from './components/home/order/order-single/order-single.component';
import { ExpensesTotalReportComponent } from './components/home/reports/expenses-total-report/expenses-total-report.component';
import { CurrencyFormatPipe } from './pipes/currency-format.pipe';
import { UnitiesCostsReportComponent } from './components/home/reports/unities-costs-report/unities-costs-report.component';
import { ToastrModule } from 'ng6-toastr-notifications';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { GasTicketEmmitComponent } from './components/home/travel/gas-ticket-emmit/gas-ticket-emmit.component';
import { GasTicketCardComponent } from './components/home/travel/gas-ticket-card/gas-ticket-card.component';
import { ReceiptComponent } from './components/home/receipt/receipt.component';
import { ProecoReportComponent } from './components/home/reports/proeco-report/proeco-report.component';
import { DashboardComponent } from './components/home/dashboard/dashboard.component';
import { TravelEditComponent } from './components/home/travel/travel-edit/travel-edit.component';
import { GasTicketReComponent } from './components/home/travel/gas-ticket-re/gas-ticket-re.component';
import { MaintenanceDashboardComponent } from './components/home/dashboard/maintenance-dashboard/maintenance-dashboard.component';
import { TravelContractedComponent } from './components/home/travel/travel-contracted/travel-contracted.component';
import { KmReportComponent } from './components/home/reports/km-report/km-report.component';
import { UnitiesReportComponent } from './components/home/reports/unities-report/unities-report.component';
import { ExpensesJobComponent } from './components/home/extra-expense/expenses-job/expenses-job.component';
import { RequisitionCreateComponent } from './components/home/pusrchases/requisition-create/requisition-create.component';
import { RequisitionComponent } from './components/home/pusrchases/requisition/requisition.component';
import { PurchaseOrderComponent } from './components/home/pusrchases/purchase-order/purchase-order.component';
import { PurchaseOrderCreateComponent } from './components/home/pusrchases/purchase-order-create/purchase-order-create.component';
import { RequisitionSingleComponent } from './components/home/pusrchases/requisition-single/requisition-single.component';
import { PurchaseOrderSingleComponent } from './components/home/pusrchases/purchase-order-single/purchase-order-single.component';
import { EntryComponent } from './components/home/pusrchases/entry/entry.component';
import { EntryCreateComponent } from './components/home/pusrchases/entry-create/entry-create.component';
import { EntrySingleComponent } from './components/home/pusrchases/entry-single/entry-single.component';
import { WarehouseComponent } from './components/home/pusrchases/warehouse/warehouse.component';
import { PurchaseOrderReportComponent } from './components/home/reports/purchase-order-report/purchase-order-report.component';
import { ArticleOutputComponent } from './components/home/pusrchases/article-output/article-output.component';
import { TravelPaysheetReportComponent } from './components/home/reports/travel-paysheet-report/travel-paysheet-report.component';
import { DocNotificationComponent } from './components/home/doc-notification/doc-notification.component';
import { EntryReportComponent } from './components/home/reports/entry-report/entry-report.component';
import { ExpenseTollboothComponent } from './components/home/expense/expense-tollbooth/expense-tollbooth.component';
import { DriverAvatarComponent } from './components/home/driver/driver-avatar/driver-avatar.component';
import { GasUnityEmmitComponent } from './components/home/unity/gas-unity-emmit/gas-unity-emmit.component';
import { ProecoReportAllComponent } from './components/home/reports/proeco-report-all/proeco-report-all.component';
import { WarehouseHistoryComponent } from './components/home/pusrchases/warehouse-history/warehouse-history.component';
import { GasReportAllComponent } from './components/home/reports/gas-report-all/gas-report-all.component';
import { UnityDetailComponent } from './components/shared/unity-detail/unity-detail.component';
import { WharehouseSapComponent } from './components/shared/wharehouse-sap/warehouse-sap.component';
import { PendingGasComponent } from './components/home/unity/pending-gas/pending-gas.component';
import { ScheduleComponent } from './components/home/travel/schedule/schedule.component';
import { BinnacleReportComponent } from './components/home/reports/binnacle-report/binnacle-report.component';
import { PurchaseOrderSapReportComponent } from './components/home/reports/purchase-order-sap-report/purchase-order-sap-report.component';
import { EntrySapReportComponent } from './components/home/reports/entry-sap-report/entry-sap-report.component';
import { ServiceComponent } from './components/home/unity/service/service.component';
import { UnityContratorComponent } from './components/home/unity/unity-contrator/unity-contrator.component';
import { UnitiesServicesReportComponent } from './components/home/reports/unities-services-report/unities-services-report.component';
import { UtilitarianComponent } from './components/home/utilitarian/utilitarian.component';
import { UtilitarianTableComponent } from './components/home/utilitarian/utilitarian-table/utilitarian-table.component';
import { UnityVerificationComponent } from './components/home/unity/unity-verification/unity-verification.component';
import { ServiceCalendarComponent } from './components/home/unity/service-calendar/service-calendar.component';
import { CalendarSharedComponent } from './components/shared/calendar/calendar.component';
import { Select2Module } from 'ng2-select2';
import { AngularMultiSelectModule } from 'angular2-multiselect-dropdown';
import { InvoiceTicketComponent } from './components/home/invoice-ticket/invoice-ticket.component';
import { DatetimeFormatPipe } from './pipes/datetime-format.pipe';
import { InternalTravelDocumentsComponent } from './components/home/internal-travel-documents/internal-travel-documents.component';
import { CommercialDocumentsComponent } from './components/home/commercial-documents/commercial-documents.component';
import {CommercialDocumentsFormComponent } from './components/home/commercial-documents/commercial-documents-form/commercial-documents-form.component';
import { TravelSupportComponent } from './components/shared/travel-support/travel-support.component';
import { AngularDateTimePickerModule } from 'angular2-datetimepicker';
import { TravelRoutesComponent } from './components/home/travel/travel-routes/travel-routes.component';
import { ExpenseTypeComponent } from './components/home/expense-type/expense-type.component';
import { LoadsCalendarComponent } from './components/home/travel/loads-calendar/loads-calendar.component';
import { TravelCreateParticularComponent } from './components/home/travel/travel-create-particular/travel-create-particular.component';

Date.prototype.toISOString = function() {
  return this.getFullYear() + "-" +
  (this.getMonth() + 1 < 10 ? "0" + (this.getMonth() + 1) : (this.getMonth() + 1)) + "-" + 
  (this.getDate() < 10 ? "0" + this.getDate() : this.getDate()) + "T" + 
  (this.getHours() < 10 ? "0" + this.getHours() : this.getHours()) + ":" + 
  (this.getMinutes() < 10 ? "0" + this.getMinutes() : this.getMinutes());
};

Date.prototype.toString = function() {
  return this.getFullYear() + "-" +
  (this.getMonth() + 1 < 10 ? "0" + (this.getMonth() + 1) : (this.getMonth() + 1)) + "-" + 
  (this.getDate() < 10 ? "0" + this.getDate() : this.getDate());
};

FullCalendarModule.registerPlugins([
  dayGridPlugin,
  interactionlugin,
  timeGridlugin,
  listPlugin
]);

@NgModule({
  declarations: [
    AppComponent,
    NavbarComponent,
    LoginComponent,
    PrincipalComponent,
    PathComponent,
    UsersComponent,
    AuthComponent,
    CustomersComponent,
    ConfComponent,
    SupplierComponent,
    UnityComponent,
    UnityCardComponent,
    UnitySingleComponent,
    ProductComponent,
    OrderComponent,
    OrderCreateComponent,
    DriverComponent,
    ExpenseComponent,
    RouteComponent,
    RouteNewComponent,
    AddressPipe,
    PostalCodeComponent,
    RouteCreateComponent,
    RouteCardComponent,
    SetComponent,
    SetCardComponent,
    RouteTestComponent,
    ArticleComponent,
    TravelListComponent,
    TravelCreateComponent,
    TravelSingleComponent,
    MaintenanceOrderCreateComponent,
    MaintenanceOrderListComponent,
    MaintenanceOrderCardComponent,
    UnityPipe,
    CalendarComponent,
    LoadsCalendarComponent,
    CalendarCardComponent,
    PaysheetExpensesComponent,
    GasTicketComponent,
    MaintenanceCreateComponent,
    MaintenanceListComponent,
    ExtraExpenseComponent,
    PaysheetComponent,
    MarketPriceComponent,
    PaysheetBaseComponent,
    GasReportComponent,
    MaintenanceReportComponent,
    ExtraExpenseReportComponent,
    PaysheetReportComponent,
    OrderEditComponent,
    RoleAbilityComponent,
    AbilityToRoleComponent,
    TravelCardComponent,
    RouteEditComponent,
    OrderSingleComponent,
    ExpensesTotalReportComponent,
    CurrencyFormatPipe,
    UnitiesCostsReportComponent,
    GasTicketEmmitComponent,
    GasTicketCardComponent,
    ReceiptComponent,
    ProecoReportComponent,
    DashboardComponent,
    TravelEditComponent,
    GasTicketReComponent,
    MaintenanceDashboardComponent,
    TravelContractedComponent,
    KmReportComponent,
    UnitiesReportComponent,
    ExpensesJobComponent,
    RequisitionCreateComponent,
    RequisitionComponent,
    PurchaseOrderComponent,
    PurchaseOrderCreateComponent,
    RequisitionSingleComponent,
    PurchaseOrderSingleComponent,
    EntryComponent,
    EntryCreateComponent,
    EntrySingleComponent,
    WarehouseComponent,
    PurchaseOrderReportComponent,
    ArticleOutputComponent,
    TravelPaysheetReportComponent,
    DocNotificationComponent,
    EntryReportComponent,
    ExpenseTollboothComponent,
    DriverAvatarComponent,
    GasUnityEmmitComponent,
    ProecoReportAllComponent,
    WarehouseHistoryComponent,
    GasReportAllComponent,
    UnityDetailComponent,
    WharehouseSapComponent,
    PendingGasComponent,
    ScheduleComponent,
    BinnacleReportComponent,
    PurchaseOrderSapReportComponent,
    EntrySapReportComponent,
    ServiceComponent,
    UnityContratorComponent,
    UnitiesServicesReportComponent,
    UtilitarianComponent,
    UtilitarianTableComponent,
    UnityVerificationComponent,
    ServiceCalendarComponent,
    CalendarSharedComponent,
    InvoiceTicketComponent,
    DatetimeFormatPipe,
    InternalTravelDocumentsComponent,
    CommercialDocumentsComponent,
    CommercialDocumentsFormComponent,
    TravelSupportComponent,
    TravelRoutesComponent,
    ExpenseTypeComponent,
    TravelCreateParticularComponent,
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    NgbModule,
    FormsModule,
    AgmCoreModule.forRoot({ // @agm/core
      apiKey: 'AIzaSyD4uxvhLBEGZ98z8V5REOvu1xv-JRodwx4',
    }),
    AgmDirectionModule, // agm-direction
    APP_ROUTING,
    BrowserAnimationsModule,
    ToastrModule.forRoot(),
    FullCalendarModule, // Calendario
    NgxPaginationModule, // Paginacion
    Select2Module,
    AngularMultiSelectModule,
    AngularDateTimePickerModule
  ],
  providers: [
    AuthService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ApiInterceptor,
      multi: true,
    },
    {
      provide: LOCALE_ID,
      useValue: "es" 
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
